import { Routes } from '@angular/router';
import { WorkSpaceSettingsRouting } from './pages/workspace-settings/workspace-settings-routing';
import { IntegrationRoutes } from './pages/workspace-settings/pages/integrations/integrations-routing';
import { IntegrationDatRoutes } from './pages/workspace-settings/pages/integrations/pages/integrations-dat/integrations-dat-routing';
import { IntegrationTruckstopRoutes } from './pages/workspace-settings/pages/integrations/pages/integrations-truckstop/integrations-truckstop-routing';
import { IntegrationTelegramRoutes } from './pages/workspace-settings/pages/integrations/pages/integrations-telegram/integrations-telegram-routing';
import { ToolsRoutes } from './pages/tools/tools-routing';

const base = `workspace-settings/${WorkSpaceSettingsRouting.INTEGRATIONS}`;

export const APP_REDIRECT_ROUTES: Routes = [
  {
    path: 'organization/integrations',
    redirectTo: base,
    pathMatch: 'full',
  },
  {
    path: 'organization/integrations/DAT',
    redirectTo: `${base}/${IntegrationRoutes.DAT}`,
    pathMatch: 'full',
  },
  {
    path: 'organization/integrations/DAT/users',
    redirectTo: `${base}/${IntegrationRoutes.DAT}/${IntegrationDatRoutes.USERS}`,
    pathMatch: 'full',
  },
  {
    path: 'organization/integrations/DAT/authentication',
    redirectTo: `${base}/${IntegrationRoutes.DAT}/${IntegrationDatRoutes.AUTHENTICATION}`,
    pathMatch: 'full',
  },
  {
    path: 'organization/integrations/Truckstop',
    redirectTo: `${base}/${IntegrationRoutes.TRUCKSTOP}`,
    pathMatch: 'full',
  },
  {
    path: 'organization/integrations/Truckstop/users',
    redirectTo: `${base}/${IntegrationRoutes.TRUCKSTOP}/${IntegrationTruckstopRoutes.USERS}`,
    pathMatch: 'full',
  },
  {
    path: 'organization/integrations/Truckstop/authentication',
    redirectTo: `${base}/${IntegrationRoutes.TRUCKSTOP}/${IntegrationTruckstopRoutes.AUTHENTICATION}`,
    pathMatch: 'full',
  },
  {
    path: 'organization/integrations/Telegram',
    redirectTo: `${base}/${IntegrationRoutes.TELEGRAM}`,
    pathMatch: 'full',
  },
  {
    path: 'organization/integrations/Telegram/users',
    redirectTo: `${base}/${IntegrationRoutes.TELEGRAM}/${IntegrationTelegramRoutes.USERS}`,
    pathMatch: 'full',
  },
  {
    path: 'organization/integrations/Telegram/chats',
    redirectTo: `${base}/${IntegrationRoutes.TELEGRAM}/${IntegrationTelegramRoutes.CHATS}`,
    pathMatch: 'full',
  },
  {
    path: 'organization/integrations/Telegram/authentication',
    redirectTo: `${base}/${IntegrationRoutes.TELEGRAM}/${IntegrationTelegramRoutes.AUTHENTICATION}`,
    pathMatch: 'full',
  },
  {
    path: 'system/accessorial-fee-types',
    redirectTo: `workspace-settings/${WorkSpaceSettingsRouting.ACCESSORIAL_FEE_TYPES}`,
    pathMatch: 'full',
  },
  {
    path: 'system/equipment-types',
    redirectTo: `workspace-settings/${WorkSpaceSettingsRouting.EQUIPMENT_TYPES}`,
    pathMatch: 'full',
  },
  {
    path: 'system/reference-types',
    redirectTo: `workspace-settings/${WorkSpaceSettingsRouting.REFERENCE_TYPES}`,
    pathMatch: 'full',
  },
  {
    // Services page was removed as redundant - old links land on the dashboard
    path: 'organization/services',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'system/freight-requirements',
    redirectTo: `workspace-settings/${WorkSpaceSettingsRouting.FREIGHT_REQUIREMENTS}`,
    pathMatch: 'full',
  },
  {
    path: 'finance/commission-summary',
    redirectTo: 'finance/commissions',
    pathMatch: 'full',
  },
  {
    path: 'finance/commission-summary/:id',
    redirectTo: 'finance/commissions/:id',
    pathMatch: 'full',
  },
  {
    path: 'tools/commodity-search',
    redirectTo: `tools/${ToolsRoutes.COMMODITY_SEARCH}`,
    pathMatch: 'full',
  },
  {
    path: 'tools/commodity-search/:nmfc',
    redirectTo: `tools/${ToolsRoutes.COMMODITY_SEARCH}/:nmfc`,
    pathMatch: 'full',
  },
  {
    // Clients were renamed to Customers - old links, including deep profile tab
    // links, keep working. Deliberately a prefix match (no `pathMatch: 'full'`)
    // so the unmatched remainder is carried over: /clients -> /customers and
    // /clients/42/edi -> /customers/42/edi.
    // NOTE: cannot use `AppRoutes.CUSTOMERS` here - app-routing.ts imports this
    // file, so importing the enum back would be a circular dependency.
    path: 'clients',
    redirectTo: 'customers',
  },
];
